import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges} from '@angular/core';
import {Picture} from '../../catalogs/catalogs.model';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss']
})
export class GalleryComponent implements OnInit {
  @Input() images: Picture[];
  @Input() addImageButtonText: string;
  @Input() noImageButtonText: string;
  @Input() showAddButton: boolean;

  @Output() change = new EventEmitter<Picture[]>();

  visibleImages = [];
  showingCount = 6;

  constructor() {}

  ngOnInit() {
    if(this.images)
      this.visibleImages = [...this.images.slice(0, this.showingCount)];
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['images'] && this.images) {
      this.visibleImages = [...this.images.slice(0, this.showingCount)];
    }
  }

  handleImageClick(index) {}

  handleAdd() {
    this.change.emit(this.images);
  }

  showMore() {
    this.visibleImages = [
      ...this.visibleImages,
      ...this.images.slice(this.showingCount, this.showingCount + 3)
    ];
    this.showingCount += 3;
  }
}
